import { useEffect, useMemo } from 'react';
import {
    Dialog, DialogContent,
    DialogTitle,
    IconButton
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import FormProvider from 'src/components/hook-form';
import Iconify from 'src/components/iconify';
import UserNewForm from '../../../admin-users/new-user/create-user-form';

export const KanbanCardCreateModal = ({ open, onClose, reload, currentItem }) => {
    const theme = useTheme();
    const NewDocumentSchema = Yup.object().shape({
    });
    // Default values based on currentItem
    const defaultValues = useMemo(() => ({

    }), [ currentItem ]);
    const methods = useForm({
        resolver: yupResolver(NewDocumentSchema),
        defaultValues,
    });
    const { reset, handleSubmit, formState: { isSubmitting } } = methods;

    useEffect(() => {
        reset(defaultValues);
    }, [ currentItem, reset, defaultValues ]);

    const onSubmit = handleSubmit(async (data) => {
    });

    return (
        <Dialog
            open={ open }
            onClose={ (event, reason) => {
                if (reason !== 'backdropClick') {
                    onClose();
                }
            } }
            fullWidth
            maxWidth="lg"
            sx={ {
                borderRadius: 'none',
                padding: '60px',
                fontSize: '13px',
                fontFamily: 'arial',
            } }
            transitionDuration={ {
                enter: theme.transitions.duration.shortest,
                exit: theme.transitions.duration.shortest - 80,
            } }
        >
            <FormProvider methods={ methods } onSubmit={ onSubmit }>
                <DialogTitle sx={ { display: 'flex', justifyContent: 'space-between', alignItems: 'center' } }>
                    <span
                        className="cardColor"
                        style={ {
                            padding: '7px', marginLeft: '-25px', fontWeight: '700',
                            backgroundColor: "#F4F6F8",
                            color: '#637381'
                        } }
                    >
                        &nbsp;&nbsp; Create Admin User &nbsp;&nbsp;&nbsp;&nbsp;
                    </span>
                    <IconButton onClick={ onClose }>
                        <Iconify icon="mdi:close" />
                    </IconButton>
                </DialogTitle>
                <DialogContent>
                    <UserNewForm />

                </DialogContent>
                {/* <DialogActions>
                    <Button variant="outlined" color="inherit" onClick={ onClose }>
                        Cancel
                    </Button>
                    <LoadingButton
                        type="submit"
                        variant="contained"
                        className="dark-button"
                        loading={ isSubmitting }
                    >
                        { currentItem?.id ? "Update" : "Create" }
                    </LoadingButton>
                </DialogActions> */}
            </FormProvider>
        </Dialog>
    );
};
